export default {
  title: 'Connexion',
  label: {
    id: 'Identifiant',
    password: 'Mot de passe'
  },
  forgotPassword: 'Mot de passe oublié ?',
  loginBtn: 'Connexion'
}
